import script from "./ProductList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductList.vue?vue&type=script&lang=ts&setup=true"

import "./ProductList.vue?vue&type=style&index=0&id=3178a2e5&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3178a2e5"]])

export default __exports__